

































//#region imports
import UsersGetListResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/UserService/UsersGetListResponse";
import UserFilterModel from "@models/users/userFilterModel";
import { Vue, Component, Inject } from "vue-property-decorator";
import UserService from "@/api/dataSource/api/Spirit/Admin/Services/UserService";
import NewCustomToggleSwitcher from "@/components/slider/new-custom-switcher.vue";
//#endregion

@Component({
   components: {
    'new-custom-toggle-switcher': NewCustomToggleSwitcher,
  },
})
export default class PageUsersComponent extends Vue {
  filter: UserFilterModel = new UserFilterModel();
  columnNames = [ 
    '#',
    'Картинка',
    'Имя',
    'Email',
    'Максимальная серия',
    'Текущая серия',
    'Окончание подписки',
    'Создано',
    'Всего прослушано',
    'Блок'
  ];
  getDataFunc = this.$api.UserService.getListAsync.bind(this.$api.UserService);
  async created() {}

onChangeBlocked(data: UsersGetListResponse) {  
  this.$api.UserService.toggleIsBlockedAsync(data.Id);
}
}
